/* @flow */

import camelCase from 'lodash/camelCase';

import cssColors from './css-colors';

export const colors: {[colorName: ColorName]: string} = Object.keys(cssColors).reduce(
    (accum, colorName: string) => {
        const cleanedColorName = colorName.replace(/^--(color-)?/, '');
        accum[camelCase(cleanedColorName)] = cssColors[colorName];

        return accum;
    },
    {}
);

// This is annoying, but since we're camelCasing programatically, flow doesn't know the literal
// color name values.  It's still worth making them in a loop, but this gives us a bit more safety
// as well as better autocomplete in editors.
export type ColorName =
    | 'orange'
    | 'orangeDk'
    | 'orangeLt'
    | 'orangeXlt'
    | 'orangeAttention'
    | 'peach'
    | 'peachLt'
    | 'grey'
    | 'greyDk'
    | 'greyLt'
    | 'greyXlt'
    | 'greyBlue'
    | 'black'
    | 'white'
    | 'offWhite'
    | 'offWhiteDk'
    | 'offWhiteMd'
    | 'offWhiteCream'
    | 'offWhiteSidebar'
    | 'offWhiteTransparent'
    | 'formBorder'
    | 'label'
    | 'plum'
    | 'plumDk'
    | 'plumLt'
    | 'plumXlt'
    | 'plumBgDk'
    | 'onboardingHelpLt'
    | 'onboardingHelp'
    | 'onboardingHelpDk'
    | 'navy'
    | 'navyDk'
    | 'navyLt'
    | 'blue'
    | 'blueDk'
    | 'blueLt'
    | 'blueXlt'
    | 'blueBg'
    | 'nutshellPro'
    | 'aiBlue'
    | 'aiHover'
    | 'support'
    | 'supportHover'
    | 'focusBlue'
    | 'slateBlue'
    | 'slateBlueLt'
    | 'green'
    | 'greenDk'
    | 'greenLt'
    | 'greenXlt'
    | 'rose'
    | 'roseDk'
    | 'roseLt'
    | 'red'
    | 'redDk'
    | 'redLt'
    | 'sidebarRed'
    | 'brown'
    | 'brownLt'
    | 'yellow'
    | 'yellowLt'
    | 'error'
    | 'warning'
    | 'dotcomTeal'
    | 'dotcomPurple'
    | 'modalOverlay'
    | 'listHovered'
    | 'listSelected'
    | 'flashBannerErrorText'
    | 'flashBannerErrorBackground'
    | 'textHot'
    | 'textAccounts'
    | 'textContacts'
    | 'textUsers'
    | 'placeholder'
    | 'product'
    | 'productBgHovered'
    | 'backgroundHot'
    | 'tinyIntroLogin'
    | 'tinyIntroSignup'
    | 'tinyIntroTeal'
    | 'tinyIntroOffWhite'
    | 'activity'
    | 'task'
    | 'person'
    | 'company'
    | 'lead'
    | 'leadHovered'
    | 'reportGreen'
    | 'reportBlue'
    | 'reportRed'
    | 'reportOrange'
    | 'reportOrangeBg'
    | 'reportNavy'
    | 'sidebarPrimary'
    | 'sidebarHovered'
    | 'buttonSecondaryDk'
    | 'upgrade'
    | 'skeletonGrey'
    | 'tagGreyLt'
    | 'tagGrey'
    | 'tagGreyDk'
    | 'tagRed'
    | 'tagRedLt'
    | 'tagRedDk'
    | 'tagOrange'
    | 'tagOrangeLt'
    | 'tagOrangeDk'
    | 'tagYellow'
    | 'tagYellowLt'
    | 'tagYellowDk'
    | 'tagGreen'
    | 'tagGreenLt'
    | 'tagGreenDk'
    | 'tagBlue'
    | 'tagBlueLt'
    | 'tagBlueDk'
    | 'tagPurple'
    | 'tagPurpleLt'
    | 'tagPurpleDk'
    | 'overdue'
    | 'success'
    | 'successBg'
    | 'navyXltNew'
    | 'navyBgNew'
    | 'navyBgActiveNew'
    | 'secondarySidebarHoverBlue'
    | 'sidebarSecondary'
    | 'rcfxSidebarActive'
    | 'messengerBlue'
    | 'instagramPink'
    | 'zoomBlue'
    | 'googleGreen'
    | 'teamsBlue'
    | 'sidebarListLoading'
    | 'whatsappGreen'
    | 'whatsappGreenDk'
    // 2025 AI rebrand
    | 'aiPurplePinkXxlt'
    | 'aiPurplePinkXlt'
    | 'aiPurplePinkLt'
    | 'aiPurplePinkMd'
    | 'aiPurplePink'
    | 'aiPurpleXlt'
    | 'aiPurpleLt'
    | 'aiPurpleMd'
    | 'aiPurplePrimary'
    | 'aiPurpleDk'
    | 'aiPurpleBorder'
    | 'aiPurpleBg';
